export default __webpack_public_path__ + "static/media/rank.06544eb7.png";